import PATH from 'crono-fe-common/constants/path';

// When an unauthenticated request hits a 401 we redirect to the login page,
// carrying the current path as `returnUrl`. The Okta SSO flow lands back on the
// app with an `?ssoError=...` query param (e.g. `/?ssoError=sso_user_not_found`);
// since `returnUrl` is built from the pathname only, that param would be dropped
// and the login page could never surface the error. We forward it explicitly.
export const buildLoginRedirectPath = (
  pathname: string,
  search: string,
): string => {
  const base = `${PATH.LOGIN}?returnUrl=${pathname}`;
  const ssoError = new URLSearchParams(search).get('ssoError');
  return ssoError ? `${base}&ssoError=${encodeURIComponent(ssoError)}` : base;
};
